import HttpService from "./htttp.service";

class EntitiesService {
  getEntities = async (query, cancelToken) => {
    const endpoint = "entities";
    return await HttpService.get(endpoint, query, cancelToken);
  };

  createEntity = async (payload) => {
    const endpoint = "entities";
    return await HttpService.post(endpoint, payload);
  };

  removeEntity = async (id) => {
    const endpoint = "entities/" + id;
    return await HttpService.delete(endpoint, id);
  };

  updateEntity = async (id, payload) => {
    const endpoint = "entities/" + id;
    return await HttpService.put(endpoint, payload);
  };

  getNextEntityReferenceCode = async () => {
    const endpoint = "entities/next";
    return await HttpService.get(endpoint);
  };
}

export default new EntitiesService();
